// extracted by mini-css-extract-plugin
export default {"wrapper":"dbdm05Vutaio1KPpMrC9qA=="};